import toastMsg from '../../../../../../lib/toastMsg';
import appToastMsg from '../../../../../../constants/service/toastMsg/appToastMsg';
import { useGeneratePointMutate } from './query';

export const useGeneratePoint = () => {
  const { mutateAsync } = useGeneratePointMutate({
    options: {
      onSuccess: () => toastMsg.success(appToastMsg.GENERATE_POINT_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  });

  return { generatePoint: mutateAsync };
};
